import { render } from "./AdminsList.vue?vue&type=template&id=0a1163ec&scoped=true"
import script from "./AdminsList.vue?vue&type=script&lang=js"
export * from "./AdminsList.vue?vue&type=script&lang=js"

import "./AdminsList.vue?vue&type=style&index=0&id=0a1163ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1163ec"]])

export default __exports__